import React, { createContext, useContext, useState, useCallback } from 'react'

const CartContext = createContext()

export const useCartContext = () => {
  const context = useContext(CartContext)
  if (!context) {
    throw new Error('useCartContext must be used within a CartProvider')
  }
  return context
}

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(
    localStorage.getItem('cartItems') !== null ? JSON.parse(localStorage.getItem('cartItems')) : []
  )

  // Define the dispatch function to handle actions
  const dispatch = useCallback(
    (action) => {
      switch (action.type) {
        case 'ADD_ITEM': {
          const { newItem } = action.payload
          const existingItemIndex = cartItems.findIndex(
            (item) => item.slug === newItem.slug && item.size === newItem.size
          )
          if (existingItemIndex !== -1) {
            const updatedCartItems = [...cartItems]
            updatedCartItems[existingItemIndex].quantity += newItem.quantity
            setCartItems(updatedCartItems)
            // Update localStorage
            localStorage.setItem('cartItems', JSON.stringify(updatedCartItems))
          } else {
            setCartItems([...cartItems, newItem])
            // Update localStorage
            localStorage.setItem('cartItems', JSON.stringify([...cartItems, newItem]))
          }
          break
        }
        case 'UPDATE_ITEM': {
          const { slug, updatedQuantity } = action.payload

          const updatedCartItems = cartItems.map((item) => {
            if (item.slug === slug) {
              return { ...item, quantity: updatedQuantity }
            }
            return item
          })
          setCartItems(updatedCartItems)

          // Update localStorage with the updated cartItems
          localStorage.setItem('cartItems', JSON.stringify(updatedCartItems))
          break
        }
        case 'REMOVE_ITEM': {
          const { itemToRemove } = action.payload
          const updatedCartItems = cartItems.filter(
            (item) => item.slug !== itemToRemove.slug || item.size !== itemToRemove.size
          )
          setCartItems(updatedCartItems)
          // Remove the item from localStorage as well
          localStorage.setItem('cartItems', JSON.stringify(updatedCartItems))
          break
        }
        case 'REMOVE_ALL_ITEMS': {
          setCartItems([])
          // Remove all items from localStorage as well
          localStorage.removeItem('cartItems')
          break
        }
        default:
          break
      }
    },
    [cartItems]
  )

  const addItem = (newItem) => {
    dispatch({ type: 'ADD_ITEM', payload: { newItem } })
  }

  const updateItem = (slug, updatedQuantity) => {
    dispatch({ type: 'UPDATE_ITEM', payload: { slug, updatedQuantity } })
  }

  const removeItem = (itemToRemove) => {
    dispatch({ type: 'REMOVE_ITEM', payload: { itemToRemove } })
  }
  const removeAllItems = () => {
    dispatch({ type: 'REMOVE_ALL_ITEMS' })
  }
  return (
    <CartContext.Provider value={{ cartItems, addItem, updateItem, removeItem, removeAllItems }}>
      {children}
    </CartContext.Provider>
  )
}
